import { useCallback } from 'react';

import usePost from 'lib/hooks/usePost';
import { confirmRichAction, SwalToast } from 'lib/utils/toast';

// Shared cancel-run hook for both Brand SKU Mapper review views (MFR->DP + v2).
// cancelRun(body) confirms, then POSTs to `endpoint`; onCancelled refetches the run state.
export default function useCancelRun(endpoint, onCancelled) {
  const { postData, loading } = usePost(
    endpoint,
    () => {
      SwalToast('success', 'Run cancelled.');
      if (onCancelled) onCancelled();
    },
    err => SwalToast('error', err?.response?.data?.message || 'Could not cancel the run.'),
  );

  const cancelRun = useCallback(
    (body = {}) =>
      confirmRichAction(
        () => postData(body),
        'Cancel the current run? Any products already scored are kept; the rest are skipped.',
        'Cancel run?',
        'Yes, cancel run',
      ),
    [postData],
  );

  return { cancelRun, cancelling: loading };
}
